import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, message } from "antd";
import API from "../../api";

const CategoryDrawer = ({ open, setOpen, data, isEdit, onSubmit }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      if (isEdit && data) {
        form.setFieldsValue(data);
      } else {
        form.resetFields();
      }
    }
  }, [open, isEdit, data, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      let response;
      if (isEdit) {
        response = await API.put(`/category/${data?._id}`, values);
        message.success("Category updated successfully!");
        onSubmit({ ...values, _id: data?._id });
      } else {
        response = await API.post(`/category`, values);
        message.success("Category added successfully!");
        onSubmit(response?.data);
      }
      setOpen(false);
    } catch (err) {
      console.error(err);
      message.error(err.response?.data?.message || "Failed to process the request.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title={isEdit ? "Edit Category" : "Add Category"}
      width={450}
      placement="right"
      onClose={() => setOpen(false)}
      open={open}
    >
      <Form layout="vertical" form={form} onFinish={onFinish} autoComplete="off">
        {isEdit && (
          <Form.Item name="_id" hidden>
            <Input type="hidden" />
          </Form.Item>
        )}

        <Form.Item
          label="Category Name"
          name="name"
          rules={[{ required: true, message: "Please enter the category name." }]}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <Button type="primary" block htmlType="submit" loading={isLoading}>
            {isEdit ? "Update Category" : "Add Category"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default CategoryDrawer;
